import React, { useState } from 'react';
export function Offer() {
  const [bonusOpen, setBonusOpen] = useState(false);
  const bonuses = [{
    num: '1',
    name: 'El Arsenal del Arquitecto — Prompt-Pack de Alto Ticket'
  }, {
    num: '2',
    name: 'Kit de Cierre de Contratos Globales'
  }, {
    num: '3',
    name: 'De Cero a Soberanía — Plan de Acción de 90 Días'
  }, {
    num: '4',
    name: 'Glosario Técnico del Arquitecto Digital'
  }];
  return <section id="oferta" className="py-8 md:py-[120px] px-4 md:px-12 relative z-10 overflow-hidden" aria-label="Oferta principal" data-id="element-167">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] bg-[radial-gradient(circle,rgba(255,215,0,0.05)_0%,transparent_70%)] pointer-events-none" aria-hidden="true" data-id="element-168" />
      <div className="max-w-[760px] mx-auto relative z-10" data-id="element-169">
        <div className="bg-gradient-to-br from-gold-soft to-black/80 border border-border-glow rounded-2xl p-5 md:p-14 text-center relative overflow-hidden" data-id="element-170">
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold to-cyan" aria-hidden="true" data-id="element-171" />

          <span className="text-[2.2rem] md:text-[3rem] block mb-3 md:mb-6 animate-float-skull drop-shadow-[0_0_20px_rgba(0,245,255,0.5)]" role="img" aria-label="Calavera digital" data-id="element-172">
            💀
          </span>
          <div className="inline-block bg-gradient-to-r from-gold-dark to-gold text-black font-body text-[0.55rem] md:text-[0.65rem] font-extrabold tracking-[2px] md:tracking-[3px] uppercase px-4 md:px-6 py-1.5 md:py-2 rounded-sm mb-5 md:mb-8" data-id="element-173">
            🔥 Acceso de Fundadores · Edición 2025
          </div>

          <h2 className="font-display text-[clamp(1.8rem,4vw,3.5rem)] tracking-[2px] leading-[1.1] mb-5 md:mb-12" data-id="element-174">
            TODO EL ARSENAL
            <br data-id="element-175" />
            <span className="text-gold" data-id="element-176">POR UNA FRACCIÓN</span>
            <br data-id="element-177" />
            DE SU VALOR REAL
          </h2>

          <div className="flex flex-col gap-2 md:gap-3 mb-5 md:mb-8 text-left" data-id="element-178">
            <div className="flex items-center justify-between p-3 md:p-5 bg-white/[0.02] border border-border-glow rounded-xl" data-id="element-179">
              <div className="flex items-center gap-2 md:gap-3" data-id="element-180">
                <span className="text-[1rem] md:text-[1.25rem]" aria-hidden="true" data-id="element-181">
                  📘
                </span>
                <span className="text-[0.75rem] md:text-[0.9rem] font-semibold text-white" data-id="element-182">
                  Método Creador Millonario
                </span>
              </div>
              <span className="text-[0.75rem] md:text-[0.85rem] text-text-muted line-through font-display tracking-[1px] shrink-0 ml-2" data-id="element-183">
                $29
              </span>
            </div>

            <div className="rounded-xl border border-border overflow-hidden transition-all duration-300 hover:border-border-glow" data-id="element-184">
              <button onClick={() => setBonusOpen(!bonusOpen)} className="w-full flex items-center justify-between p-3 md:p-5 bg-white/[0.02] hover:bg-gold-soft transition-colors cursor-pointer select-none" aria-expanded={bonusOpen} data-id="element-185">
                <div className="flex items-center gap-2 md:gap-3" data-id="element-186">
                  <span className="text-[1rem] md:text-[1.25rem]" aria-hidden="true" data-id="element-187">
                    🎁
                  </span>
                  <span className="text-[0.75rem] md:text-[0.9rem] font-semibold text-gold" data-id="element-188">
                    + 4 Bonus Exclusivos
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-189">
                  <span className="text-[0.75rem] md:text-[0.85rem] text-text-muted line-through font-display tracking-[1px] shrink-0" data-id="element-190">
                    $18
                  </span>
                  <span className={`text-gold text-[0.9rem] transition-transform duration-300 ${bonusOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-191">
                    ▾
                  </span>
                </div>
              </button>
              <div className={`overflow-hidden transition-all duration-400 ${bonusOpen ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-192">
                <div className="flex flex-col gap-1.5 md:gap-2 p-3 md:p-5 pt-0 md:pt-0 bg-white/[0.01]" data-id="element-193">
                  {bonuses.map(bonus => <div key={bonus.num} className="flex items-start gap-2 md:gap-2.5 py-1.5 md:py-2" data-id="element-194">
                      <span className="text-[0.65rem] md:text-[0.7rem] font-display text-gold bg-gold-soft border border-border-glow px-1.5 py-0.5 rounded shrink-0 mt-0.5" data-id="element-195">
                        {bonus.num}
                      </span>
                      <span className="text-[0.72rem] md:text-[0.85rem] text-text-silver leading-[1.4]" data-id="element-196">
                        {bonus.name}
                      </span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center px-3 md:px-5 py-3 md:py-5 border-t border-border mb-5 md:mb-10" data-id="element-197">
            <span className="text-[0.78rem] md:text-[0.9rem] text-text-muted tracking-[2px] uppercase" data-id="element-198">
              Valor Total Real
            </span>
            <span className="font-display text-[1.1rem] md:text-[1.5rem] text-text-muted line-through tracking-[2px]" data-id="element-199">
              $47 USD
            </span>
          </div>

          <div className="mb-6 md:mb-12" data-id="element-200">
            <p className="text-[0.65rem] md:text-[0.75rem] tracking-[3px] text-text-muted uppercase mb-1" data-id="element-201">
              Tu inversión hoy
            </p>
            <div className="font-display text-[clamp(5rem,12vw,9rem)] leading-none bg-gradient-to-br from-gold-dark via-gold to-gold-light text-gradient drop-shadow-[0_0_30px_rgba(255,215,0,0.3)] tracking-[4px]" aria-label="Precio $14.94" data-id="element-202">
              $14.94
            </div>
            <p className="text-[0.7rem] md:text-[0.8rem] text-text-muted tracking-[2px] mt-1" data-id="element-203">
              USD · Pago único · Acceso inmediato y permanente
            </p>
          </div>

          <a href="https://freedomdigitalco.com/cart/45627056619718:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if ((window as any).fbq) {
            ;
            (window as any).fbq('track', 'AddToCart', {
              content_name: 'Método Creador Millonario',
              content_type: 'product',
              value: 14.94,
              currency: 'USD'
            });
          }
        }} className="cta-primary inline-flex items-center justify-center gap-3 md:gap-4 w-full bg-gradient-to-r from-gold-dark via-gold to-gold-light bg-[length:300%_100%] text-black px-6 md:px-8 py-4 md:py-6 rounded-md font-body text-[0.78rem] md:text-[1rem] font-extrabold tracking-[1px] md:tracking-[2px] uppercase no-underline" aria-label="Obtener acceso inmediato" data-id="element-204">
            QUIERO MI EXOESQUELETO DIGITAL AHORA{' '}
            <span className="cta-arrow text-lg" data-id="element-205">→</span>
          </a>

          <div className="flex items-center justify-center gap-3 md:gap-5 mt-4 md:mt-6 flex-wrap" data-id="element-206">
            {[{
            icon: '🔒',
            label: 'Pago Seguro'
          }, {
            icon: '⚡',
            label: 'Acceso Inmediato'
          }, {
            icon: '🛡️',
            label: 'Garantía 7 Días'
          }, {
            icon: '💳',
            label: 'USD · USDT · Tarjeta'
          }].map((b, i) => <span key={i} className="flex items-center gap-1 text-[0.6rem] md:text-[0.75rem] text-text-muted tracking-[1px]" data-id="element-207">
                <span className="text-[0.75rem] md:text-[0.85rem]" aria-hidden="true" data-id="element-208">
                  {b.icon}
                </span>
                {b.label}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}